/* LIKEMOGLI — Mission-Funnel: Multi-Step-Qualifizierung mit Datums-Picker */
(function () {
  'use strict';

  var funnel = document.getElementById('MissionFunnel');
  if (!funnel) return;

  var steps = Array.prototype.slice.call(funnel.querySelectorAll('.funnel__step'));
  var bar = funnel.querySelector('.funnel__progress-bar');
  var label = funnel.querySelector('.funnel__progress-label');
  var backBtn = funnel.querySelector('.funnel__back');
  var nextBtn = funnel.querySelector('.funnel__next');
  var navWrap = funnel.querySelector('.funnel__nav');
  var progressWrap = funnel.querySelector('.funnel__progress');
  var form = funnel.querySelector('form');
  var current = 0;
  var lastTrigger = null;

  /* ---------- Öffnen / Schließen ---------- */
  function openFunnel(trigger) {
    lastTrigger = trigger || null;
    funnel.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var preset = trigger && trigger.getAttribute('data-funnel-expedition');
    if (preset) {
      var input = funnel.querySelector('input[name="contact[was]"][value="' + preset + '"]');
      if (input) input.checked = true;
    }
    goTo(0);
    funnel.querySelector('.funnel__close').focus();
  }
  function closeFunnel() {
    funnel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-funnel-open]');
    if (trigger) {
      e.preventDefault();
      openFunnel(trigger);
    }
  });
  funnel.querySelector('.funnel__close').addEventListener('click', closeFunnel);
  funnel.addEventListener('click', function (e) {
    if (e.target === funnel) closeFunnel();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && funnel.classList.contains('is-open')) closeFunnel();
  });

  /* ---------- Navigation ---------- */
  function goTo(index) {
    current = index;
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
      s.classList.remove('has-error');
    });
    var pct = ((index + 1) / steps.length) * 100;
    bar.style.width = pct + '%';
    label.textContent = 'Schritt ' + (index + 1) + ' / ' + steps.length;
    backBtn.hidden = index === 0;
    nextBtn.textContent = index === steps.length - 1 ? nextBtn.getAttribute('data-submit-label') : nextBtn.getAttribute('data-next-label');
    if (index === steps.length - 1) buildSummary();
    funnel.scrollTop = 0;
  }

  function validate(index) {
    var step = steps[index];
    var need = step.getAttribute('data-validate');
    if (!need) return true;
    var ok = true;
    if (need === 'radio') {
      ok = !!step.querySelector('input[type="radio"]:checked');
    } else if (need === 'date') {
      var flex = funnel.querySelector('input[name="contact[flexibel]"]');
      var start = funnel.querySelector('input[name="contact[start]"]');
      ok = (flex && flex.checked) || (start && start.value !== '');
    } else if (need === 'contact') {
      var nameInput = step.querySelector('input[name="contact[name]"]');
      var mail = step.querySelector('input[name="contact[email]"]');
      ok = nameInput.value.trim() !== '' && mail.value.trim() !== '' && mail.checkValidity();
    }
    step.classList.toggle('has-error', !ok);
    return ok;
  }

  backBtn.addEventListener('click', function () {
    if (current > 0) goTo(current - 1);
  });
  nextBtn.addEventListener('click', function () {
    if (!validate(current)) return;
    if (current < steps.length - 1) {
      goTo(current + 1);
    } else {
      submitFunnel();
    }
  });

  /* ---------- Kalender (Datumsbereich) ---------- */
  var cal = funnel.querySelector('.fun-cal');
  if (cal) {
    var monthEl = cal.querySelector('.fun-cal__month');
    var gridEl = cal.querySelector('.fun-cal__grid');
    var prevBtn = cal.querySelector('[data-cal-prev]');
    var nxtBtn = cal.querySelector('[data-cal-next]');
    var selEl = cal.querySelector('.fun-cal__selection');
    var startInput = funnel.querySelector('input[name="contact[start]"]');
    var endInput = funnel.querySelector('input[name="contact[ende]"]');
    var flexToggle = funnel.querySelector('input[name="contact[flexibel]"]');
    var today = new Date();
    var minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 21);
    var view = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var selStart = null;
    var selEnd = null;
    var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    var WDAYS = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

    function iso(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    function fmt(d) {
      return d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
    }

    function render() {
      monthEl.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
      gridEl.innerHTML = '';
      WDAYS.forEach(function (w) {
        var el = document.createElement('span');
        el.className = 'fun-cal__wd';
        el.textContent = w;
        gridEl.appendChild(el);
      });
      var firstDay = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7;
      var days = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var i = 0; i < firstDay; i++) {
        var pad = document.createElement('button');
        pad.type = 'button';
        pad.className = 'fun-cal__day is-empty';
        pad.tabIndex = -1;
        gridEl.appendChild(pad);
      }
      var _loop = function (d) {
        var date = new Date(view.getFullYear(), view.getMonth(), d);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fun-cal__day';
        btn.textContent = d;
        if (date < minDate) {
          btn.disabled = true;
        } else {
          if (selStart && date.getTime() === selStart.getTime()) btn.classList.add('is-edge');
          if (selEnd && date.getTime() === selEnd.getTime()) btn.classList.add('is-edge');
          if (selStart && selEnd && date > selStart && date < selEnd) btn.classList.add('in-range');
          btn.addEventListener('click', function () { pick(date); });
        }
        gridEl.appendChild(btn);
      };
      for (var d = 1; d <= days; d++) _loop(d);
      prevBtn.disabled = view.getFullYear() === minDate.getFullYear() && view.getMonth() === minDate.getMonth();
      updateSelection();
    }

    function pick(date) {
      if (!selStart || (selStart && selEnd)) {
        selStart = date;
        selEnd = null;
      } else if (date < selStart) {
        selStart = date;
      } else {
        selEnd = date;
      }
      startInput.value = selStart ? iso(selStart) : '';
      endInput.value = selEnd ? iso(selEnd) : '';
      render();
    }

    function updateSelection() {
      if (flexToggle.checked) {
        selEl.innerHTML = 'Zeitraum: <strong>flexibel</strong> — wir finden gemeinsam das beste Fenster.';
      } else if (selStart && selEnd) {
        var nights = Math.round((selEnd - selStart) / 86400000);
        selEl.innerHTML = '<strong>' + fmt(selStart) + '</strong> bis <strong>' + fmt(selEnd) + '</strong> · ' + nights + ' Nächte';
      } else if (selStart) {
        selEl.innerHTML = 'Start: <strong>' + fmt(selStart) + '</strong> — wähle dein Enddatum.';
      } else {
        selEl.textContent = 'Wähle dein Startdatum (frühestens in 3 Wochen).';
      }
    }

    prevBtn.addEventListener('click', function () {
      view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
      render();
    });
    nxtBtn.addEventListener('click', function () {
      view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
      render();
    });
    flexToggle.addEventListener('change', function () {
      cal.style.opacity = flexToggle.checked ? '0.35' : '1';
      cal.style.pointerEvents = flexToggle.checked ? 'none' : '';
      updateSelection();
    });
    render();
  }

  /* ---------- Zusammenfassung ---------- */
  function val(name) {
    var checked = funnel.querySelector('input[name="contact[' + name + ']"]:checked');
    if (checked) return checked.value;
    var field = funnel.querySelector('[name="contact[' + name + ']"]');
    return field ? field.value : '';
  }
  function fmtIso(s) {
    if (!s) return '';
    var p = s.split('-');
    return parseInt(p[2], 10) + '.' + parseInt(p[1], 10) + '.' + p[0];
  }
  function buildSummary() {
    var box = funnel.querySelector('.funnel__summary');
    if (!box) return;
    var flex = funnel.querySelector('input[name="contact[flexibel]"]');
    var zeitraum = (flex && flex.checked) ? 'Flexibel' : (val('start') && val('ende') ? fmtIso(val('start')) + ' bis ' + fmtIso(val('ende')) : fmtIso(val('start')) || '—');
    box.innerHTML =
      'Expedition: <strong>' + (val('was') || '—') + '</strong><br>' +
      'Zeitraum: <strong>' + zeitraum + '</strong><br>' +
      'Crew: <strong>' + (val('crew') || '—') + '</strong> · Level: <strong>' + (val('level') || '—') + '</strong>';
  }

  /* ---------- Absenden ---------- */
  function submitFunnel() {
    nextBtn.disabled = true;
    if (form.hasAttribute('data-demo')) {
      showSuccess();
      return;
    }
    form.submit();
  }
  function showSuccess() {
    steps.forEach(function (s) { s.classList.remove('is-active'); });
    navWrap.hidden = true;
    progressWrap.hidden = true;
    funnel.querySelector('.funnel__success').hidden = false;
  }

  /* Bei Shopify: nach Redirect mit ?contact_posted=true Erfolg zeigen */
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    openFunnel(null);
    showSuccess();
  }
})();
